import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { saveWorkingCodexInfo } from "./CodexVersion.actions";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import CodexVersionDisplayBar from "components/CodexVersionDisplayBar";
import { sendAuthenticatedAsyncRequest } from "services/AsyncRequestService";
import CodexVersionList from "components/CodexVersionList";

const CodexVersion = () => {
  const [codexVersions, setCodexVersions] = useState(null);
  const [loadingCodexVersions, setLoadingCodexVersions] = useState(false);
  const [selectedCodexVersion, setSelectedCodexVersion] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchCodexVersions = () => {
    setLoadingCodexVersions(true);
    sendAuthenticatedAsyncRequest(
      `/cat/codex-versions`,
      "GET", 
      null,
      (r) => {
        setCodexVersions(r.data);
        setLoadingCodexVersions(false);
      },
      (r) => {
        setCodexVersions(null);
        setLoadingCodexVersions(false);
      }
    );
  };

  useEffect(() => {
    fetchCodexVersions();
  }, []);

  const handleCodexVersionChange = (versionObj) => {
    setSelectedCodexVersion(versionObj);
    const {
      version,
      codexVersionId,
      creationDate,
      tag,
      status,
      firstApprovalBy,
    } = versionObj;

    dispatch(
      saveWorkingCodexInfo(
        version,
        codexVersionId,
        creationDate,
        tag,
        status,
        firstApprovalBy
      )
    );
    navigate("/cat/codex/dsg");
  };

    return (
      <Container fluid>
        <CodexVersionDisplayBar />
      <Row className="top-spacer">
        <Col md={{ offset: '2', span: '8' }}>
            <h4>Select a Codex Version to get started </h4>
          <div className="big-top-spacer">
            <label>Select a Working Codex Version</label>
              <CodexVersionList
                noDataText={'No codex versions found'} 
                data={codexVersions || []} 
                loading={loadingCodexVersions}
              selectedCodexVersionId={
                selectedCodexVersion
                  ? selectedCodexVersion.codexVersionId
                  : -1
              }
              onSelect={handleCodexVersionChange}
              />
            </div>
          </Col>
        </Row>
      </Container>
    );
};

export default CodexVersion;